import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { AlertService, DqcsEventsService, ResourceService } from 'sce-core';
import { UserService } from '../../core/security/user.service';
import { ModalService } from './modal.service';
import { SearchableEntityDataService } from './searchable-entity/searchable-entity-data.service';
import { SearchService } from '../search/search.service';
import { JreportLookupComponent } from '../lookup/jreport-lookup/jreport-lookup.component';
import { DATA_TO_REMOVE, META_DATA, PRINT_SOURCES, REPORT_TYPES, SEARCH_KEYS } from 'app/constants';
import { Subscription } from 'rxjs';
import { HttpStatusCode } from '../models/http-status-code.constants';
import { MessageType } from '../models/message-type.config';
import { COMMONPROPERTIES } from '../models/common-fields';

@Injectable()
export class JReportPrinterService {

  protected hasAdditionalFields: Boolean = false;
  public printerId: any;
  public parentDataService: SearchableEntityDataService;
  public tableSearchServiceForWaveControl: SearchService;
  public printReportSubscription: Subscription;
  public data: any;
  constructor(
    protected http$: HttpClient,
    protected alertService: AlertService,
    protected modalService: ModalService,
    protected resourceService: ResourceService,
    protected userService: UserService,
    private readonly dqcsEventService: DqcsEventsService
  ) { }

  private publishPrintEvents(input: any) {
    const items = Array.isArray(input) ? input : [input];
    items.forEach((request: any) => {
      this.dqcsEventService.publishReportPrintEvent({
        type: request.printSource || PRINT_SOURCES.JREPORT,
        reportId: request.reportID || request.reportId,
        document: request.documentType,
        storer: request.storerkey,
        facility: request.facility
      });
    });
  }

  /* [LFWM-2027] - documnetType - tableid
  * storer - storerkey value from parent screen
  * facility - facility value from parent screen
  * dataService - dataService of parent screen
  * primaryDataMap - primaryDataMap from parent screen
  * tableSearchService - its a optional parameter - [for wave control screen - tableSearchService is passed from wave control
    screen because which has more than one detail search service and detail table.
  */
  public printReport(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any, tableSearchService?: any) {
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      'documentType': documentType,
      'storer': storer,
      'facility': facility,
    };
    this.getModuleReport(reportDefaultValues)
      .subscribe((resp: any) => {
        const dataToRemove: Array<string> = [
          'ExtendedParmDefault1',
          'ExtendedParmDefault2',
          'ExtendedParmDefault3',
          'ExtendedParmDefault4',
          'ExtendedParmDefault5',
          'ReportTitle',
          'NeedExtendedParm'];
        Object.keys(resp)
          .forEach((key: string) => {
            if (dataToRemove.indexOf(key) !== -1) {
              delete resp[key];
            }
          });
        tempList = <any[]>resp;
        if (this.userService.userInfo.defaultPrinter) {
          this.printerId = this.userService.userInfo.defaultPrinter;
          this.invokePrintModal(tempList, reportDefaultValues,
            this.printerId, primaryDataMap, false, null, 'DocReport', null);
        } else {
          this.userService.fetchDefaultPrinter()
            .subscribe((printeresp: any) => {
              this.printerId = printeresp;
              this.invokePrintModal(tempList, reportDefaultValues,
                this.printerId, primaryDataMap, false, null, 'DocReport', null);
            });
        }
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }

  public printFromViewReportScreen(reportConfig: any,
    rowDataMap: any, dataEditor: any, keyEventHandler: any) {
    if (this.userService.userInfo.defaultPrinter) {
      this.printerId = this.userService.userInfo.defaultPrinter;
      this.invokePrintModal(reportConfig, rowDataMap, this.printerId,
        rowDataMap, true, dataEditor, 'ViewReport', keyEventHandler);
    } else {
      this.userService.fetchDefaultPrinter()
        .subscribe((printeresp: any) => {
          this.printerId = printeresp;
          this.invokePrintModal(reportConfig, rowDataMap, this.printerId,
            rowDataMap, true, dataEditor, 'ViewReport', keyEventHandler);
        });
    }
  }

  public invokePrintModal(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any) {
    this.alertService.clearAll();
    const modalRef: any = this.modalService
      .showModal(JreportLookupComponent,
        {
          overlayHeader: this.resourceService.get('btn_label_jreport'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor && modalRef && modalRef.content) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    const isInitialDataSet = modalRef && modalRef.content && modalRef.content.setInitialData && typeof modalRef.content.setInitialData === 'function';
    if (isInitialDataSet) {
      modalRef.content.setInitialData(reportConfig, inputValues,
        printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService, this.tableSearchServiceForWaveControl);
    }
    if (modalRef && modalRef.content) {
      modalRef.content.jReportprintReportReceiveEvent()
      .subscribe((requestData: any) => {
        /** Add URL fetch API here */
        /** Sample response format
         * {
              "printresp": [
                  {
                      "error": 0,
                      "errorMsg": null,
                      "success": 200,
                      "successMessage": "Successful",
                      "rowNo": 1,
                      "reportId": "R000000011",
                      "detailRowId": 47,
                      "reportURL": "https://lflreportdev.lfuat.net/jinfonet/tryView.jsp?jrs.report=/China/WMS%20UAT/PB/RPT_NSP_PVH_POD_DY.cls&jrs.catalog=/China/WMS%20UAT/CN_WMS_UAT.cat&jrs.result_type=2&jrs.param$PARAM_WMS_c_Mbolkey="
                  }
              ],
              "statusCode": 200,
              "statusMessage": "SUCCESS"
          }
         */
        this.submitPrintReport(requestData)
          .subscribe((response: any) => {
            if (response.statusCode === 200 && response.printresp) {
              const printresp = response.printresp[0];
              //Handling success case
              if (printresp.success === 200
                && printresp.successMessage === 'Successful') {
                if (printresp.reportURL) {
                  // console.log("requestData",requestData[0])
                  this.data = requestData[0];
                  // this.data is undefined when refresh the page
                  // [UWP-55726][[WMS] [ASIA main & main20] TypeError: Cannot read properties of undefined (reading 'iframeUrl')]
                  if(this.data) {
                    this.data.iframeUrl = printresp.reportURL;
                  }
                  const reportId = this.data ? this.data.reportID : null;
                  modalRef.hide();
                  this.parentDataService.buttonService.submitJreport(reportId);
                  const successMsg = 'msg_prnt_succ';
                  this.alertService.clearAll().success(this.resourceService.get(successMsg));
                } else {
                  this.alertService.clearAll().error(this.resourceService.get('jreport_url_not_available'));
                  modalRef.hide();
                }
              } else {
                this.handlePrintError(printresp.errorMsg, modalRef);
              }
            } else {
              this.handlePrintError(response.statusMessage, modalRef);
            }

          }, (err) => {
            this.handlePrintError(err, modalRef);
          });
      });
    }
  }
  public printSearchReport(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any, selectedShipRefKeys: any, useBackendForJReportPrinting: boolean, tableSearchService?: any) {
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      [COMMONPROPERTIES.DOCUMENT_TYPE]: documentType,
      [COMMONPROPERTIES.STORER]: storer,
      [COMMONPROPERTIES.FACILITY]: facility,
    };
    this.getModuleReport(reportDefaultValues)
      .subscribe((resp: any) => {
        for (const key of Object.keys(resp)) {
          if (DATA_TO_REMOVE.includes(key)) {
            delete resp[key];
          }
        }
        tempList = <any[]>resp;
        this.userService.fetchDefaultPrinter()
          .subscribe(
            (printeresp: any) => {
              this.printerId = printeresp;
              this.invokeSearchPrintModal(
                tempList,
                reportDefaultValues,
                this.printerId,
                primaryDataMap,
                false,
                null,
                REPORT_TYPES.DOC_REPORT,
                null,
                selectedShipRefKeys,
                useBackendForJReportPrinting
              );
            },
            (err: any) => {
              this.alertService.clearAll()
                .error(this.resourceService.translateServerResponse(err));
            }
          );
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }
  public invokeSearchPrintModal(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any, selectedShipRefKeys: any, useBackendForJReportPrinting: boolean) {
    this.alertService.clearAll();
    if (this.printReportSubscription) {
      this.printReportSubscription.unsubscribe();
    }
    const modalRef: any = this.modalService
      .showModal(JreportLookupComponent,
        {
          overlayHeader: this.resourceService.get('btn_label_jreport'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor && modalRef && modalRef.content) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    const isInitialDataSet = modalRef && modalRef.content && modalRef.content.setInitialData && typeof modalRef.content.setInitialData === 'function';
    if (isInitialDataSet) {
      modalRef.content.setInitialData(reportConfig, inputValues,
        printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService, this.tableSearchServiceForWaveControl);
    }
    if (modalRef && modalRef.content) {
      this.printReportSubscription = modalRef.content.jReportprintReportReceiveEvent()
      .subscribe((requestData: any) => {
        if (useBackendForJReportPrinting) {
          requestData[0].printSource = PRINT_SOURCES.JREPORT_BE;
        }
        const payload = selectedShipRefKeys.length === 1 ? requestData : this.generatePrintPayload(requestData, selectedShipRefKeys);
        this.submitPrintReport(payload)
          .subscribe((response: any) => {
            if (response.statusCode === HttpStatusCode.ok && response.printresp) {
              const printresp = response.printresp[0];
              //Handling success case
              if (printresp.success === HttpStatusCode.ok
                && printresp.successMessage === MessageType.msgSuccessful) {
                  this.alertService.clearAll().success(this.resourceService.get('msg_prnt_succ'));
                  modalRef.hide();
              } else {
                this.handlePrintError(printresp.errorMsg, modalRef);
              }
            } else {
              this.handlePrintError(response.statusMessage, modalRef);
            }

          }, (err) => {
            this.handlePrintError(err, modalRef);
          });
      });
    }
  }
   // Helper method to generate payload
  private generatePrintPayload(requestData: any, primaryKeys: any): any {
    return requestData.flatMap((item: any) =>
        primaryKeys.map((id: string) => {
            const updatedPrintParams = item.printParams.map((param: any) =>
                param.displayLabel === META_DATA.MBOL_KEY || param.displayLabel === SEARCH_KEYS.RECEIPT_KEY ? { ...param, value: id } : param
            );
            return { ...item, printParams: updatedPrintParams };
        })
    );
  }
  public getModuleReport(reportDefaultValues: any) {
    const request = {
      'documentType': reportDefaultValues.documentType,
      'storerkey': reportDefaultValues.storer,
      'facility': reportDefaultValues.facility,
      'computerName': '',
      'printSource': 'JReport'
    };

    const response$ = this.http$.post('api/report/module/report', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

  public submitPrintReport(printReportInput: any) {
    // LFWM-1811 : Print service url change
    this.publishPrintEvents(printReportInput);

    const response$ = this.http$.post('api/report/print', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200 ) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

  public getViewReportDetails(reportType: any) {
    const request = {
      'moduleID': 'ViewReport',
      'reportID': reportType.trim()
    };
    const response$ = this.http$.post('api/report/viewReport/params', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

  public submitViewReportPrint(printReportInput) {
    this.publishPrintEvents(printReportInput);

    const response$ = this.http$.post('api/report/viewReport/print', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

  /**
   * Helper method to handle print errors and hide modal
   * @param errorMessage - The error message to display
   * @param modalRef - The modal reference to hide
   */
  private handlePrintError(errorMessage: any, modalRef: any): void {
    this.alertService.clearAll().error(this.resourceService.translateServerResponse(errorMessage));
    modalRef.hide();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/jreport-printer.service.ts